// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { ComponentType } from "react";

import { TenantId } from "../../../RootStore/types";
import { UsCoParolePublicCalendarView } from "../UsCo/UsCoParolePublicCalendarView";

/**
 * Each state's own Parole Public Calendar page. Every state whose tenant
 * navigation lists the publicCalendar parole page needs an entry.
 *
 * This mapping lives beside the page rather than in the tenant config on
 * purpose: a tenant config that imported a page component would pull in
 * NavigationLayout and close a module-load cycle (see SectionAnchor).
 */
export const PUBLIC_CALENDAR_COMPONENTS_BY_TENANT: Partial<
  Record<TenantId, ComponentType>
> = {
  US_CO: UsCoParolePublicCalendarView,
};
